<template>
  <div 
    class="subprogram-nba-school-card"
  >
    <span
      v-text="i18n('entities.school.name')"
      class="subprogram-nba-school-card__title"
    ></span>
    <div class="subprogram-nba-school-card__container">
      <span
        v-text="schoolName"
        class="subprogram-nba-school-card__container__name"
      ></span>
      <div class="subprogram-nba-school-card__container__location">
        <i class="icon-location subprogram-nba-school-card__container__location__icon"></i>
        <span
          v-text="schoolLocation"
          class="subprogram-nba-school-card__container__location__name"
        />
      </div>
      <el-button
        v-if="!isRegularSeasonConfigured"
        @click="doUnmatch({ teamId: teamId, schoolId: schoolId })"
        class="subprogram-nba-school-card__container__edit"
      >
      <span v-text="i18n('entities.school.unmatch')" />
      </el-button>
      <!-- <router-link
        :to="{name: 'SubprogramNbaSchoolTeamEdit', params: {schoolId}}"
        class="subprogram-nba-school-card__container__edit"
      >
        <el-button icon="icon-pen" circle />
      </router-link> -->
    </div>
  </div>
</template>

<script>
import { i18n } from '@shared/i18n';
import { mapActions, mapGetters } from 'vuex';
import { get } from 'lodash';

export default {
  name: 'app-subprogram-nba-school-card',

  props: {
    schoolId: {
      type: String
    }, 
    schoolName: {
      type: String,
    },
    schoolLocation: {
      type: String,
    },
    teamId: {
      type: String
    }
  },

  computed: {
    ...mapGetters({
      subprogram: 'subprogram/nba/subprogram'
    }),
    isRegularSeasonConfigured() {
      return get(this, 'subprogram.regularSeasonConfigured', false);
    }
  },

  methods: {
    ...mapActions({
      doUnmatch: 'subprogram/nbaTeam/summary/doUnmatch',
    }),
    i18n(code) {
      return i18n(code);
    },
  },
};
</script>

<style lang="scss" scoped>
.subprogram-nba-school-card {
  padding-top: 20px;
  &__title {
    font-size: 20px;
    color: #6c6c6c;
    text-transform: uppercase;
  }
  &__container {
    box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
    padding: 40px;
    margin-top: 20px;
    display: grid;
    grid-template-areas: 'name button' 'location button';
    grid-template-rows: 30px 30px;
    align-items: center;
    &__name {
      grid-area: name;
      font-size: 18px;
      color: #5d5d5d;
      font-weight: 600;
    }
    &__location {
      grid-area: location;
      color: #999999;
      &__icon {
        font-size: 16px;
        padding-right: 8px;
      }
    }
    &__edit {
      grid-area: button;
      justify-self: flex-end;
    }
  }
}
</style>